// Portalled to the body, so a modal would otherwise read a click in one as outside itself and close.
const PORTALLED_OVERLAYS = ".pac-container, #__filestack-picker, .fancybox__dialog, .fancybox__container";

function keepModalOpenForPortalledOverlays(event: Event) {
  if ((event.target as HTMLElement | null)?.closest(PORTALLED_OVERLAYS)) {
    event.preventDefault();
  }
}

export const nuxtUiThemeProps = {
  modal: { content: { onInteractOutside: keepModalOpenForPortalledOverlays } },
};
